import {ExpandedChecksList} from '@github-ui/mergebox/components/sections/checks/ExpandedChecksList'
import type {StatusCheck, StatusRollup} from '@github-ui/mergebox/page-data/payloads/status-checks'
import {MergeBoxExpandable} from '@github-ui/mergebox/components/sections/common/MergeBoxExpandable'
import styles from './ChecksSection.module.css'
import type {MergeBoxPullRequest} from '../use-mergeability-data'
import {usePullRequestAnalytics} from '../../../../../hooks/use-pull-request-analytics'
import {useCallback} from 'react'

interface ChecksSectionProps {
  statusChecks: StatusCheck[]
  mergeBoxPullRequest: MergeBoxPullRequest
  statusRollup: StatusRollup
  itemName: string
}

export function ChecksSection({statusChecks, mergeBoxPullRequest, statusRollup, itemName}: ChecksSectionProps) {
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const sendChecksAction = useCallback(
    (actionName: string) =>
      sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
        item_name: itemName,
        action_name: actionName,
      }),
    [itemName, sendPullRequestAnalyticsEvent],
  )

  return (
    <div>
      <MergeBoxExpandable isExpanded wrapperClassName={styles.wrapper} contentClassName={styles.content}>
        <ExpandedChecksList
          statusChecks={statusChecks}
          statusRollupSummary={statusRollup.summary}
          pullRequestId={mergeBoxPullRequest.id}
          mergeBoxUserPreferences={mergeBoxPullRequest.mergeBoxUserPreferences}
          viewerCanUseCopilotCodingAgent={mergeBoxPullRequest.viewerCanUseCopilotCodingAgent}
          viewerHasCEOrCBAccess={mergeBoxPullRequest.viewerHasCEOrCBAccess}
          onActionSelect={sendChecksAction}
        />
      </MergeBoxExpandable>
    </div>
  )
}
